import { AgentSessionEvent } from "./agentSessionEventSlice";
import { createRestSlice } from "./restSlice";

export type AgentSessionUsage = {
  sessionStart: number;
  sessionEnd: number;
  sessionDuration: number;
  ttsDuration: number;
  ttsCachedDuration: number;
  moduleDuration: number;
};

export type Test = {
  name: string;
  options: Record<string, number>;
  value: string;
  description?: string;
};

export type OutcomeType = "boolean" | "integer" | "float" | "string";

export type Outcome = {
  name: string;
  type: OutcomeType;
  value: string;
  description?: string;
};

export type Testing = {
  tests: Record<string, Test>;
  outcomes: Record<string, Outcome>;
};

export type AgentSession = {
  id: string;
  agentId: string;
  agentEnvironmentId: string;
  deploymentId?: string; // References the deployment that was active when this session was created
  status: string;
  direction: "inbound" | "outbound";
  origin: "debugger" | "web" | "phone" | "simulation" | "unknown";
  events: AgentSessionEvent[];
  usage: AgentSessionUsage;
  metrics?: Record<string, unknown>;
  telephonyCallId: string | null;
  telephonyId: string | null;
  tags?: string[];
  createdAt: Date;
  updatedAt: Date;
  deletedAt: Date | null;
  testing?: Testing;
};

const agentSessionSlice = createRestSlice<AgentSession>("agentSessions", "/v1/agents/:agentId/sessions");

export const agentSessionReducer = agentSessionSlice.reducer;
export const agentSessionActions = agentSessionSlice.actions;
